import * as constants from '../../constants/index'
import { RESET_MFA, GET_FULL_POLICIES, GET_GROUPS, INSERT_USER, GET_GROUPS_WITH_USER, GET_POLICIES, GET_USERS, GET_USERS_OPTIONS, GET_USERS_WITH_GROUPS, Policy, User, UserGroup, DELETE_USER, DELETE_POLICY, INSERT_OR_UPDATE_POLICY, GetUsersWithGroupsQuery, GET_GROUPS_WITH_USER_CLEAR, GET_FULL_POLICIES_CLEAR } from './types';
import { POST_GET_LIST } from '../../dataProvider';
import { CREATE } from 'react-admin';
import { UserModel } from './user';
//import { CREATE } from 'react-admin';


export const resetMfa = (userEmail: string) => (
    {
        type: RESET_MFA,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AUTH.RESET_MFA}` },
        payload: { data: { query: { userEmail } } }

    }
)

export const getGroupsWithUsers = (iamUserGroup: UserGroup) => (
    {
        type: GET_GROUPS_WITH_USER,
        meta: { fetch: POST_GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_GROUPS_WITH_USER}` },
        payload: { data: iamUserGroup }
    }
)

export const groupsWithUsersClear = () => (
    {
        type: GET_GROUPS_WITH_USER_CLEAR,
        payload: { data: [] }
    }
)

export const getGroups = (iamUserGroup: UserGroup) => (
    {
        type: GET_GROUPS,
        meta: { fetch: POST_GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_GROUPS}` },
        payload: { data: iamUserGroup }
    }
)
export const getUsersWithGroups = (iamUser: User) => (
    {
        type: GET_USERS_WITH_GROUPS,
        meta: { fetch: POST_GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_USERS_WITH_GROUP}` },
        payload: { data: iamUser }

    }
)

export const getUsers = (query: GetUsersWithGroupsQuery) => (
    {
        type: GET_USERS,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_USERS}` },
        payload: { data: { query } }

    }
)

export const getUsersOptions = (query: GetUsersWithGroupsQuery) => (
    {
        type: GET_USERS_OPTIONS,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_USERS_WITHOUT_PAGINATION}` },
        payload: { data: { query } }

    }
)

export const getPolicies = (iamPolicy: Policy) => (
    {
        type: GET_POLICIES,
        meta: { fetch: POST_GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_POLICIES}` },
        payload: { data: iamPolicy }
    }
)
export const getFullPolicies = (iamPolicy: Policy) => (
    {
        type: GET_FULL_POLICIES,
        meta: { fetch: POST_GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.GET_FULL_POLICIES}` },
        payload: { data: iamPolicy }
    }
)

export const fullPoliciesClear = () => (
    {
        type: GET_FULL_POLICIES_CLEAR,
        payload: { data: [], total: 0 }
    }
)

export const insertOrUpdateUser = (iamUser: UserModel) => (
    {
        type: INSERT_USER,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.INSERT_OR_UPDATE_USER}` },
        payload: { data: iamUser }
    }
)
export const deleteUser = (iamUser: UserModel) => (
    {
        type: DELETE_USER,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.DELETE_USER}` },
        payload: { data: iamUser }
    }
)

export const insertOrUpdatePolicy = (iamPolicy: Policy) => (
    {
        type: INSERT_OR_UPDATE_POLICY,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.INSERT_OR_UPDATE_POLICY}` },
        payload: { data: iamPolicy }
    }
)
export const deletePolicy = (iamPolicy: Policy) => (
    {
        type: DELETE_POLICY,
        meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.IAM.DELETE_POLICY}` },
        payload: { data: iamPolicy }
    }
)
